let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ldewZ")).then(() => parcelRequire('hMWWU'));